import React from 'react'
import { action } from '@storybook/addon-actions'
import { storiesOf } from '@storybook/react'

import { IContest, ContestGoal, ContestStatus, Currency, IContestEntry } from 'protos'

import List from '@material-ui/core/List'

import Event from 'components/Event'

const upcoming: IContest = {
  contestId: 'upcomingContestID',
  title: 'Manager of the month',
  bannerUrl: 'https://res.cloudinary.com/hbngg1ybz/image/upload/v1511187958/contests/2511_Buli_tour35.jpg',
  status: ContestStatus.CS_UPCOMING,
  startTime: Math.round(Date.now() / 1000) + 3600,
  topPrize: [{ money: { currency: Currency.CR_EUR_CENT, value: 500 } }],
  goal: { type: ContestGoal.Type.CGT_TOTAL_SCORE_BEST_X, x: 5 },
}

const live: IContest = {
  ...upcoming,
  contestId: 'liveContestID',
  status: ContestStatus.CS_LIVE,
  endTime: upcoming.startTime,
}

const over: IContest = {
  ...live,
  contestId: 'overContestID',
  status: ContestStatus.CS_OVER,
}

const ownEntryWithMoney: IContestEntry = {
  rank: 6,
  score: 523,
  prize: [{ money: { value: 500, currency: 0 } }],
}

const ownEntryWithProduct: IContestEntry = {
  rank: 6,
  score: 523,
  prize: [{ product: { title: 'XBox One X console', quantity: 1 } }],
}

storiesOf('Event', module)
  .addDecorator((story) => (
    <List style={{ padding: 0 }}>
      {story()}
    </List>
  ))
  .add('default', () => (
    <>
      <Event />
      <Event />
      <Event />
    </>
  ))
  .add('upcoming', () => (
    <>
      <Event contest={upcoming} />
      <Event contest={upcoming} />
      <Event contest={upcoming} />
    </>
  ))
  .add('live', () => (
    <>
      <Event contest={live} />
      <Event contest={{ ...live, ownEntry: ownEntryWithMoney }} />
      <Event contest={live} />
    </>
  ))
  .add('over', () => (
    <>
      <Event contest={over} />
      <Event contest={{ ...over, ownEntry: ownEntryWithMoney }} />
      <Event contest={{ ...over, unclaimedPrize: true, ownEntry: ownEntryWithMoney }} onClaim={action('Event.onClaim')} />
      <Event contest={{ ...over, unclaimedPrize: true, ownEntry: ownEntryWithProduct }} onClaim={action('Event.onClaim')} />
    </>
  ))
